import React from 'react'
import StateWrapper from './StateWrapper'

const NoImageState = props => <StateWrapper {...props} icon='FailPicture' />

export default NoImageState
